module.exports = __webpack_public_path__ + "fonts/6af847c.woff2";